const GTAG_SCRIPT_ID = "google-gtag-config";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let gaInitialized = false;

/** react-snap uses this user agent during prebuild prerender. */
export const isPrerender = (): boolean =>
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

export function initGA(measurementId: string): void {
  if (gaInitialized || !measurementId || isPrerender()) return;

  const loader = document.createElement("script");
  loader.async = true;
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(loader);

  const config = document.createElement("script");
  config.id = GTAG_SCRIPT_ID;
  config.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', '${measurementId}', { send_page_view: false });
  `;
  document.head.appendChild(config);

  gaInitialized = true;
}

export function logPageView(pagePath?: string, pageTitle?: string): void {
  if (isPrerender() || typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path:
      pagePath ?? `${window.location.pathname}${window.location.search}`,
    page_title: pageTitle ?? document.title,
  });
}

export function injectScript(
  src: string,
  id: string,
  options: { async?: boolean } = {},
): void {
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.async = options.async ?? true;
  script.src = src;
  document.head.appendChild(script);
}
